import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { api } from '../../lib/api';

const FREE_FEATURES = [
  'Browse the full case-study catalogue',
  'Run a curated selection of free cases end-to-end',
  'Save your progress between sessions',
  'Try the EPMA-style prescribing chart',
];

const PAID_FEATURES = [
  'Unlimited access to every case in the library',
  'Track scores across attempts',
  'Live classroom mode (when invited)',
  'New cases added regularly',
  'Cancel anytime',
];

const UpgradePage = ({ token, onBack }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleUpgrade = async () => {
    setLoading(true);
    setError('');
    try {
      const result = await api.startBillingCheckout(token);
      if (result?.url) {
        window.location.href = result.url;
      } else {
        setError('No checkout URL returned');
      }
    } catch (err) {
      setError(err?.message || 'Failed to start checkout');
      setLoading(false);
    }
  };

  return (
    <div className="student-page">
      <Container className="py-5">
        <div className="d-flex justify-content-end mb-3">
          {onBack ? (
            <Button variant="outline-secondary" size="sm" onClick={onBack}>Back</Button>
          ) : null}
        </div>
        <Row className="justify-content-center">
          <Col md={10} lg={9}>
            <div className="text-center mb-5">
              <h1 className="display-5 fw-bold mb-2">Unlock the full case library</h1>
              <p className="lead text-muted mb-0">
                Practise with every case, track your progress, and stay current as new cases are added each month.
              </p>
            </div>

            {error ? <Alert variant="danger">{error}</Alert> : null}

            <Row className="g-4">
              <Col md={6}>
                <div className="app-panel p-4 h-100">
                  <h2 className="h5 mb-3">Free</h2>
                  <p className="text-muted small mb-3">For dipping in and trying the platform</p>
                  <ul className="list-unstyled mb-0">
                    {FREE_FEATURES.map((feature) => (
                      <li key={feature} className="mb-2">
                        <i className="bi bi-check-circle text-muted me-2"></i>{feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
              <Col md={6}>
                <div className="app-panel p-4 h-100" style={{ borderColor: 'var(--app-primary)', borderWidth: 2, borderStyle: 'solid' }}>
                  <h2 className="h5 mb-3">Full access</h2>
                  <p className="text-muted small mb-3">Monthly subscription, cancel anytime</p>
                  <ul className="list-unstyled mb-4">
                    {PAID_FEATURES.map((feature) => (
                      <li key={feature} className="mb-2">
                        <i className="bi bi-check-circle-fill me-2" style={{ color: 'var(--app-primary)' }}></i>{feature}
                      </li>
                    ))}
                  </ul>
                  <div className="d-grid">
                    <Button variant="primary" size="lg" onClick={handleUpgrade} disabled={loading}>
                      {loading ? 'Redirecting…' : 'Subscribe'}
                    </Button>
                  </div>
                  <p className="text-muted text-center mt-3 mb-0 small">
                    Secure checkout via Stripe. UK VAT included where applicable.
                  </p>
                </div>
              </Col>
            </Row>

            <p className="text-muted text-center mt-5 small mb-0">
              Studying through your university? You get full access — no card needed. Sign in via your university's portal.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UpgradePage;
